module.exports = __webpack_public_path__ + "img/nav-stonesize-1.2f6fb0d.svg";